import SiteNavbar from '../../components/feature/SiteNavbar';
import FooterSection from '../home/components/FooterSection';
import BlogPageHero from './components/BlogPageHero';
import BlogPageGrid from './components/BlogPageGrid';

export default function BlogPage() {
  return (
    <div className="bg-zinc-950 min-h-screen">
      <SiteNavbar />
      <BlogPageHero />
      <BlogPageGrid />
      <FooterSection />
    </div>
  );
}
